import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies';
import { JwtService } from '../../jwt/jwt.service';
import { environment } from '../../../environments/environment';
import { UserService } from '../../common/api/user.service';

@Component({
    selector : 'app-header',
    templateUrl : './header.component.html'
})
export class HeaderComponent implements OnInit {

    registrationUrl = environment.registrationUrl;

    constructor(public router: Router, public userService: UserService, public jwtService: JwtService) {
    }

    ngOnInit() {

    }


    logout() {
      this.userService.logout();
    }

    implicitLogin() {

      this.userService.obtainAccessTokenImplictFlow();

    }

    join() {
    //   this.userService.register();
    }

     toggleClicked(event: MouseEvent) {
        const target = event.srcElement.id;
        const body = $('body');
        const menu = $('#sidebar-menu');

        // toggle small or large menu
        if (body.hasClass('nav-md')) {
            menu.find('li.active ul').hide();
            menu.find('li.active').addClass('active-sm').removeClass('active');
        } else {
            menu.find('li.active-sm ul').show();
            menu.find('li.active-sm').addClass('active').removeClass('active-sm');
        }
        body.toggleClass('nav-md nav-sm');

    }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/include/header/header.component.ts